import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
  name: "filters",
  initialState: {
    filterApplied: false,
    range: {
      startDate: null,
      endDate: new Date().toISOString(), // ✅ Convert to ISO string
      key: "range",
    },
    startTime: new Date().toISOString(), // ✅ Convert to ISO string
    endTime: new Date().toISOString(), // ✅ Convert to ISO string
    cameras: [],
    species: [],
  },
  reducers: {
    setTimeRange: (state, action) => {
      // Handle both Date objects and ISO strings
      state.startTime =
        action.payload.startTime?.toISOString?.() || action.payload.startTime;
      state.endTime =
        action.payload.endTime?.toISOString?.() || action.payload.endTime;
    },
    setFilterApplied: (state, action) => {
      state.filterApplied = action.payload;
    },
    setDateRange: (state, action) => {
      state.range = {
        ...action.payload,
        // Convert Date objects to ISO strings if they're Dates
        startDate:
          action.payload.startDate?.toISOString?.() || action.payload.startDate,
        endDate:
          action.payload.endDate?.toISOString?.() || action.payload.endDate,
        key: action.payload.key || "range",
      };
    },
    setCameras: (state, action) => {
      state.cameras = action.payload;
    },
    setSpecies: (state, action) => {
      state.species = action.payload;
    },
    resetFilters: (state) => {
      state.filterApplied = false;
      state.range = {
        startDate: null,
        endDate: new Date().toISOString(), // ✅
        key: "range",
      };
      state.startTime = new Date().toISOString(); // ✅
      state.endTime = new Date().toISOString(); // ✅
      state.cameras = [];
      state.species = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDateRange,
  setCameras,
  setSpecies,
  setFilterApplied,
  setTimeRange,
  resetFilters,
} = filterSlice.actions;

export const selectFilters = (state) => state.filters;

export default filterSlice.reducer;
